
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './sidebar';
import { Header } from './header';
import { useI18n } from '@/i18n';
import { cn } from '@/lib/utils';
import { useUiStore } from '@/stores/ui-store';

export const AppLayout: React.FC = () => {
  const { dir } = useI18n();
  const { isSidebarOpen, setSidebarOpen } = useUiStore();

  return (
    <div className="min-h-screen bg-background relative">
      <Sidebar />
      {/* Mobile Backdrop */}
      {isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-20 md:hidden animate-in fade-in duration-200"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      
      <div className={cn(
        "transition-all duration-300 flex flex-col min-h-screen", 
        dir === 'rtl' ? 'md:mr-64' : 'md:ml-64'
      )}>
        <Header />
        <main className="flex-1 p-4 md:p-6 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
